import { useState } from "react";

import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { GiftcardTable, GiftcardSearchFilter } from "./component";
import { CreateGiftcardModal } from "../../Modal/Giftcard/CreateGiftcardModal";
import type { Giftcard as GiftCardType, GiftcardProps } from "./types";
import { EditGiftCardModal } from "../../Modal/Giftcard/EditGiftcardModal";
import { DeleteGiftCardPlanModal } from "../../Modal/Giftcard/DeleteGiftCardPlan";

export const Giftcard: React.FC<GiftcardProps> = ({
  giftcardPlans,
  loading,
  statusFilter,
  setStatusFilter,
  onGiftcardPlanClick,
  searchTerm,
  setSearchTerm,
  categoryFilter,
  setCategoryFilter,
  countryFilter,
  setCountryFilter,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedGiftCardPlan, setSelectedGiftCardPlan] = useState<
    undefined | GiftCardType
  >(undefined);
  const [giftCardPlanId, setGiftCardPlanId] = useState<number | null>(null);

  const onEditClick = (giftCard: GiftCardType) => {
    setSelectedGiftCardPlan(giftCard);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setGiftCardPlanId(id);
    setIsDeleteModalOpen(true);
  };
  return (
    <ExternalContainer>
      <div className="min-h-screen dark:bg-[#FFFFFF1A] w-full max-w-7xl mx-auto px-4 py-6">
        <InternalContainer headerText="Gift Card Plans">
          <div className="flex flex-col">
            <GiftcardSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={() => setIsCreateModalOpen(true)}
              categoryFilter={categoryFilter}
              onCategoryFilter={setCategoryFilter}
              countryFilter={countryFilter}
              onCountryFilter={setCountryFilter}
              sortBy={sortBy}
              onSortByChange={setSortBy}
              sortOrder={sortOrder}
              onSortOrderChange={setSortOrder}
            />
            <div className="border border-[#FFFFFF1A] overflow-x-auto">
              <GiftcardTable
                giftcardPlans={giftcardPlans}
                statusFilter={statusFilter}
                searchTerm={searchTerm}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                onGiftcardPlanClick={onGiftcardPlanClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateGiftcardModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />

        <EditGiftCardModal
          giftCardPlan={selectedGiftCardPlan}
          isOpen={isEditModalOpen && selectedGiftCardPlan !== undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedGiftCardPlan(undefined);
          }}
        />
        <DeleteGiftCardPlanModal
          id={giftCardPlanId}
          isOpen={isDeleteModalOpen && giftCardPlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setGiftCardPlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default Giftcard;
